import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  cardTitle: localStorage.getItem('cardTitle') || '',
  procurementDivisionType : localStorage.getItem("procurementDivisionType") || "SIS"
}

export const userTypeSlice = createSlice({
  name: 'userType',
  initialState,
  reducers: {
    setActiveCardTitle: (state, action) => {
      state.cardTitle = action.payload;
      localStorage.setItem('cardTitle', action.payload);
    },
  },
})

export const { setActiveCardTitle } = userTypeSlice.actions;

export default userTypeSlice.reducer;